import { useClasser } from "@code-hike/classer";
import * as React from "react";
import { useLoadingOverlayState } from "../hooks/useLoadingOverlayState";
import { OpenInCodeSandboxButton } from "./OpenInCodeSandboxButton";
export var LoadingOverlay = function LoadingOverlay(_ref) {
  var clientId = _ref.clientId;
  var loadingOverlayState = useLoadingOverlayState(clientId);
  var c = useClasser("sp");

  if (loadingOverlayState === "hidden") {
    return null;
  }

  if (loadingOverlayState === "timeout") {
    return React.createElement("div", {
      className: c("overlay", "error")
    }, React.createElement("div", {
      className: c("error-message")
    }, "Unable to establish connection with the sandpack bundler. Make sure you are online or try again later. If the problem persists, please report it via", " ", React.createElement("a", {
      className: c("error-message"),
      href: "mailto:hello@codesandbox.io?subject=Sandpack Timeout Error"
    }, "email"), " ", "or submit an issue on", " ", React.createElement("a", {
      className: c("error-message"),
      href: "https://github.com/codesandbox/sandpack/issues",
      rel: "noreferrer noopener",
      target: "_blank"
    }, "GitHub.")));
  }

  return React.createElement("div", {
    className: c("overlay", "loading"),
    style: {
      opacity: loadingOverlayState === "visible" ? 1 : 0,
      transition: "opacity 0.5s ease-out"
    }
  }, React.createElement("div", {
    className: "sp-cube-wrapper",
    title: "Open in CodeSandbox"
  }, React.createElement(OpenInCodeSandboxButton, null), React.createElement("div", {
    className: "sp-cube"
  }, React.createElement("div", {
    className: "sp-sides"
  }, React.createElement("div", {
    className: "sp-top"
  }), React.createElement("div", {
    className: "sp-right"
  }), React.createElement("div", {
    className: "sp-bottom"
  }), React.createElement("div", {
    className: "sp-left"
  }), React.createElement("div", {
    className: "sp-front"
  }), React.createElement("div", {
    className: "sp-back"
  })))));
};